"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.toggleDetailFilter = void 0;
// @ts-ignore
var query_string_1 = __importDefault(require("query-string"));
var toggleDetailFilter = function (withDetailFilter) { return function (replace, location) {
    var url = location.pathname;
    var queryParams = query_string_1["default"].parse(location.search);
    queryParams.withDetailFilter = withDetailFilter;
    return replace({ pathname: url, search: query_string_1["default"].stringify(queryParams) });
}; };
exports.toggleDetailFilter = toggleDetailFilter;
